import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../../services/auth";
import { Footer } from "../../componentes/Footer";
import { Header } from "../../componentes/Header";
import { Navigation } from "../../componentes/Navigation";
import { Loading } from "../../componentes/Loading";

const PrivateRoute = ({ component: Component, ...rest }) => {

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <>
            <Header />
            <Loading/>
            <Navigation />
            <Component {...props} />
            <Footer />
          </>
        ) : (
          <Redirect
            to={{ pathname: "/", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;